<h1 mat-dialog-title>Reprovar Medição</h1>

<button mat-icon-button (click)="onClose()">
  <mat-icon>close</mat-icon>
</button>

<mat-horizontal-stepper [linear]="false" #stepper>
  <mat-step>
    <ng-template matStepLabel>Justificativa</ng-template>
    <div class="form-container">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label labelRequired>Justificativa</mat-label>
        <textarea
          rows="15"
          type="text"
          matInput
          [formControl]="justificativaControl"
          maxlength="1000"
        ></textarea>
      </mat-form-field>
    </div>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Anexos</ng-template>
    <app-anexos [options]="anexosOptions" #anexos></app-anexos>
  </mat-step>
</mat-horizontal-stepper>

<div mat-dialog-actions align="end">
  <app-ellipsis-animation class="loading" *ngIf="loading" />

  <button
    type="submit"
    mat-flat-button
    [disabled]="justificativaControl.invalid"
    (click)="onSubmit(anexos.files)"
  >
    Concluir
  </button>
</div>
